//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { gridMargin } from './general';

export default class FMPSwitch extends PureComponent {
	render() {
		const { label, value, path, onChange, md, withGrid } = this.props;
		const _onChange = (event) => {
			onChange(event.target.checked, path);
		};

		const content = (
			<FormControlLabel label={label} control={<Switch checked={value} onChange={_onChange} />} />
		);

		if (withGrid) {
			return (
				<Grid spacing={2} container>
					<Grid item xs={12} md={md} style={gridMargin}>
						{content}
					</Grid>
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPSwitch.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.bool.isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,
	disabled: PropTypes.bool,
	md: PropTypes.number,
	withGrid: PropTypes.bool,
};

FMPSwitch.defaultProps = {
	md: 12,
	withGrid: true,
};
